export default "__VITE_ASSET__VAQa9OS5__"